"use client"
import React from "react";
import styles from "../AvailabilitySelectionModule.module.css";
import { formatHour, formatShortDate } from "@/utils/formatDates";

interface AvailabileDayProps {
  dates: string[];
  toggleExpand: () => void;
  selectSlot: (datetime: string) => void;
}

const AvailabileDay = ({
  dates,
  selectSlot,
  toggleExpand,
}: AvailabileDayProps) => {
  const title = formatShortDate(dates[0]);
  return (
    <div className={styles.availability_day}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.availability}>
        {dates.slice(0, 3).map((date) => {
          const time = formatHour(date); //extract startime from date
          return (
            <div
              key={date}
              className={styles.slot}
              onClick={() => selectSlot(date)}
            >
              <span>{time}</span>
            </div>
          );
        })}
      </div>
      {dates.length > 3 && (
        <button
          className={styles.toggle_expand_availability}
          onClick={toggleExpand}
        >
          More times
        </button>
      )}
    </div>
  );
};

const ExpandedAvailability = ({
  dates,
  selectSlot,
  toggleExpand,
}: AvailabileDayProps) => {
  const title = formatShortDate(dates[0]);
  return (
    <div className={styles.availability_day}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.availability}>
        {dates.map((date) => {
          const time = formatHour(date); //extract startime from date
          return (
            <div
              key={date}
              className={styles.slot}
              onClick={() => selectSlot(date)}
            >
              <span>{time}</span>
            </div>
          );
        })}
      </div>
      <button
        className={styles.toggle_expand_availability}
        onClick={toggleExpand}
      >
        Go back
      </button>
    </div>
  );
};

interface AvailabilitySelectorProps {
  pages: string[][];
  state: "paginating" | "last" | "start" | "expanded";
  increment: () => void;
  decrement: () => void;
  expanded_index: number;
  toggleExpand: (index: number) => void;
  selectSlot: (datetime: string) => void;
}

const AvailabilitySelector = ({
  state,
  pages,
  increment,
  decrement,
  expanded_index,
  toggleExpand,
  selectSlot,
}: AvailabilitySelectorProps) => {
  return (
    <div className={styles.availability_container}>
      {state === "expanded" ? (
        <ExpandedAvailability
          dates={pages[expanded_index]}
          toggleExpand={() => toggleExpand(expanded_index)}
          selectSlot={selectSlot}
        />
      ) : (
        pages.map((page, index) => (
          <AvailabileDay
            key={`${page[0]}-${index}}`}
            dates={page}
            toggleExpand={() => toggleExpand(index)}
            selectSlot={selectSlot}
          />
        ))
      )}
      <div className={styles.pagination_btn_container}>
        {(state === "paginating" || state === "last") && (
          <button
            id="decrement-page"
            className={styles.pagination_btn}
            onClick={decrement}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M8.3284 10.9999L13.6924 5.63589L12.2782 4.22168L4.5 11.9999L12.2782 19.778L13.6924 18.3638L8.3284 12.9999H20.5V10.9999H8.3284Z"
                fill="#fff"
              />
            </svg>
          </button>
        )}
        {(state === "paginating" || state === "start") && (
          <button
            id="increment-page"
            className={styles.pagination_btn}
            onClick={increment}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M16.6716 10.9999L11.3076 5.63589L12.7218 4.22168L20.5 11.9999L12.7218 19.778L11.3076 18.3638L16.6716 12.9999H4.5V10.9999H16.6716Z"
                fill="#fff"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default AvailabilitySelector;
